/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

/* BEGIN GA4 datalayer events */
window.dataLayer = window.dataLayer || [];
/*document.addEventListener('variant:added', function(event) {
  var variant = event.detail.variant;
  console.log('variant:added', variant);
  window.dataLayer.push({
    event: 'add_to_cart',
    ecommerce: {
      items: [{
        item_name: variant.product_title,
        item_id: variant.sku,
        price: variant.final_price,
        item_brand: variant.vendor,
        item_category: variant.product_type,
        item_variant: variant.variant_title || 'Default Title',
        quantity: variant.quantity
      }]
    }
  });
});

document.addEventListener('variant:changed', function(event) {
  let variant = event.detail.variant;
  window.dataLayer.push({
    event: 'view_item',
    ecommerce: {
      items: [{
        item_name: variant.product_title,
        item_id: variant.sku,
        price: variant.final_price,
        item_brand: variant.vendor,
        item_category: variant.product_type,
        item_variant: variant.variant_title || 'Default Title',
        quantity: variant.quantity
      }]
    }
  });
});
*/
document.addEventListener('line-item-quantity:change:start', function(event) {
  if (event.detail.newLineQuantity > 0) {
    return;
  }
  window.dataLayer.push({
    event: 'remove_from_cart'
  });
});

/* Begin Event view_cart */
const cartIcon = document.querySelector('a[aria-label="Cart"]');
if (cartIcon !== null) {
  cartIcon.addEventListener('click', function (event) {
    try{    
      fetch('/cart.js', {
      method: 'GET',
      headers: {'Accept': 'application/json',},
      })
      .then(response => response.json())
      .then(response => {
        let arrayOfObjects = []
        for (const item of response.items) {
          let obj = {};
          obj['item_id'] = item.id;
          obj['sku'] = item.sku;
          obj['item_name'] = item.product_title;
          obj['price'] = item.price.toString().replace(/\B(?=(\d{2})(?!\d))/g, ".");
          obj['final_price'] = item.final_line_price.toString().replace(/\B(?=(\d{2})(?!\d))/g, ".");
          obj['quantity'] = item.quantity;
          arrayOfObjects.push(obj);
        }
        window.dataLayer.push({
          'event': 'view_cart',
          'currency': response.currency,
          'value': response.total_price.toString().replace(/\B(?=(\d{2})(?!\d))/g, "."),
          ecommerce: {
              items: arrayOfObjects,
            }
        });
      })
    } catch (error) {
    console.error(error);
    }
  });      
}
/* End Event view_cart */

function selectItem() {
   document.querySelectorAll('product-item.product-item').forEach(item => {
    item.addEventListener('click', function(event) {
      var productForm = this.querySelector('form.shopify-product-form');
      var productId = productForm.getAttribute('id');
      var regex = /__(\d+)_0/;
      var match = productId.match(regex);
      productId = match ? match[1] : null;
      var productTitle = this.querySelector('.product-item-meta__title').innerHTML;
      var productPrice = this.querySelector('.product-item-meta__price-list-container .price').innerHTML;
      var priceRegex = /\$(\d+\.\d+)/;
      var productPrices = productPrice.match(priceRegex);
      productPrice = productPrices ? productPrices[1] : null;
    window.dataLayer.push({
          'event': 'select_item',
          ecommerce: {
              items: [{
                name: productTitle,
                id: productId,
                price: productPrice,
                quantity: 1
            }]
          }
      });
    })
  })
}

const productCollection = document.querySelector('product-list.product-facet__product-list');
if (productCollection !== null) {
     selectItem()
  function paginationClick() {
    const pagination = document.querySelector('page-pagination.pagination');
    if (pagination !== null) {
      pagination.addEventListener('click', function(event) {
        setTimeout(() => {
        selectItem()
        paginationClick()
        }, 1000);
      })     
    }
  }
 paginationClick() 
}

/* END GA4 datalayer events */

class ProductDescription extends HTMLElement {
  constructor() {
    super();
    this.readMoreButton = this.querySelector('[data-product-desc-read-more]');
    this.init();
  }

  init() {
    this.readMoreButton && this.readMoreButton.addEventListener('click', this._onReadMoreClicked.bind(this));
  }

  _onReadMoreClicked(event) {
    this.classList.toggle('show-full-content');

    if (this.classList.contains('show-full-content')) {
      this.readMoreButton.innerHTML = 'Show less';
    } else {
      this.readMoreButton.innerHTML = 'Read more';
    }
  }
}

window.customElements.define("product-description", ProductDescription);

const scrollTrigger = {
  init() {
    this.setupScrollTrigger('[data-animate-item]');
  },

  setupScrollTrigger(elementSelector) {
    gsap.registerPlugin(ScrollTrigger);
    
    gsap.utils.toArray(elementSelector).forEach((element) => {
      const animateFrom = element.dataset.animateFrom || 'left';
      let xPercent = 100, xPercentTo = 0;
      if (animateFrom == 'left') {
        xPercent = -100
        xPercentTo = 15
      } else if (animateFrom == 'right') {
        xPercent = 100
        xPercentTo = 0
      }

      gsap.fromTo(element, {
          xPercent: xPercent,
          yPercent: 0,
        }, {
          duration: 1.5, 
          xPercent: xPercentTo,
          yPercent: 0, 
          autoAlpha: 1,
          scrollTrigger: {
            trigger: element,
            start: "top bottom", // the default values
            end: "bottom top",
            scrub: true
          }, 
        }
      );
    });
  }
};

class Animations {
  constructor() {
    gsap.registerPlugin(ScrollTrigger);
    this.fadeUp();
  }

  fadeUp() {
    const i = document.querySelectorAll(".animate.fade-up").length;
    if (!i) return;
    gsap.set(".animate.fade-up .fade", { opacity: 0, y: 60 });

    ScrollTrigger.batch(".animate.fade-up", {
      ease: "power2.out",
      start: "top 70%",
      onEnter: (batch) => {
        batch.forEach((card) => {
          gsap.to(card.querySelectorAll(".fade"), {
            duration: 1,
            opacity: 1,
            y: 0,
            stagger: { each: 0.15 },
            overwrite: true,
          });
        });
      },
    });
  }

  refresh() {
    this.fadeUp();
  }
}

const updatePromoBlocks = () => {
  let mql = window.matchMedia('(max-width: 740px)');
  const promoBlocks = [...document.querySelectorAll('.promotion-block')];
  promoBlocks.forEach((block, index) => {
    const order = parseInt(block.dataset.order);
    const previousElementOrder = promoBlocks[index-1] && parseInt(promoBlocks[index-1].dataset.order);
    if (mql.matches && order % 2 === 1) {
      if (order === previousElementOrder) {
        block.style.order = order + 1;
      } else {
        block.style.order = order - 1;
      }
    } else {
      block.style.order = order;
    }
  })
};

const handleCustomQuizResultsEvents = () => {
  document.addEventListener('click', (e) => {
    if (e.target.id === 'quiz-kit-question-radio-box-65508') {
      // If Quiz step 6 and two quiz is selected, trigger Next button
      const activeElements = document.querySelectorAll('#quiz-kit-question-radio-box-65508.active-class')
      if (activeElements.length == 2 && e.target.classList.contains('active-class')) {
        const nextButton = document.querySelector('#quiz-kit-question-next-button');
        nextButton && nextButton.click();
      }
    }
  })
};
class SwiperCarousel extends HTMLElement {
  constructor() {
    super();
    this.carouselElement = this.querySelector('.swiper');
    this.sliderOptions = {};

    this.init();
  }

  init() {
    const data = this.carouselElement.dataset.swiper || {};
    let dataOptions = null;

		if (data) {
      dataOptions = JSON.parse(data);
    }

    const defaultOptions = {
      // freeMode: true,
      mousewheel: {
        releaseOnEdges: true,
        forceToAxis: true,
      },
      // And if we need scrollbar
      scrollbar: {
        el: this.querySelector('.swiper-scrollbar'),
        hide: false,
        draggable: true,
      },
      slidesPerView: 1,
      spaceBetween: 20,
      centerInsufficientSlides: true,
    }

		this.sliderOptions = Object.assign({}, defaultOptions, dataOptions);
    
    this.initCarousel();
  }

  initCarousel() {
    const swiper = new Swiper(this.carouselElement, this.sliderOptions);
  }
}

document.addEventListener('quizKitQuestionLoaded', () => {
  handleCustomQuizResultsEvents();
});

document.addEventListener('DOMContentLoaded', () => {
  window.customElements.define("swiper-carousel", SwiperCarousel);

  if (typeof gsap !== 'undefined') {
    new Animations();

    scrollTrigger.init();
  }

  let mql = window.matchMedia('(max-width: 740px)');
  if (mql.matches) {
    updatePromoBlocks();
  }

  const handleQuizTriggerClick = () => {
    const quizTrigger = document.querySelector('[data-quiz-popup-trigger]');
    if (quizTrigger) {
      quizTrigger.click();
    }
  }

  const quizPageLinks = [...document.querySelectorAll('[href="/pages/skincare-quiz"]')];
  quizPageLinks.forEach((button) => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      handleQuizTriggerClick();
    })
  })
});

window.addEventListener('resize', () => {
  updatePromoBlocks();
})

document.addEventListener('variant:changed', function(event) {
  var variant = event.detail.variant; // Get the variant that was added
  console.log(variant);
});

// Disable Free Gift samples while loading
document.addEventListener('click', function(event) {
    if (event.target.matches('.mini-cart__recommendations .link')) {
        const recList = document.getElementsByClassName('mini-cart__recommendations-list');
        recList[0].ariaBusy = true;
    }
});

function checkGiftWithPurchase(e) {
  var t;
  'undefined' != typeof GWP_GIFT_ENABLED &&
    (e
      ? (t = $.Deferred()).resolve(e)
      : (t = $.ajax({ dataType: 'json', url: '/cart.json', cache: !1 })),
    t.done(function (e) {
      var t = 0,
        a = !1,
        i = 0,
        n = GWP_QUALIFYING_PRODUCT.split(','),
        o = GWP_EXCLUDED_PRODUCTS;
      if (
        ('thresholds' == GWP_METHOD &&
          e.items.forEach(function (e, n) {
            e.variant_id === GWP_GIFT_VARIANT_ID
              ? 0 === e.line_price
                ? (a = !0)
                : (i = n + 1)
              : e.price >= GWP_PRICE_THRESHOLD &&
                !o.includes(e.variant_id) &&
                (t += e.quantity);
          }),
        'item_specific' == GWP_METHOD &&
          e.items.forEach(function (e, t) {
            e.variant_id === GWP_GIFT_VARIANT_ID
              ? 0 === e.line_price
                ? (a = !0)
                : (i = t + 1)
              : (e.id != n[0] && e.id != n[1]) ||
                (console.log('GWP: Qualifying product exists'), (n = !0));
          }),
        'collection' == GWP_METHOD)
      ) {
        let n,
          o = document.querySelector('[data-cart-contents]');
        o && (n = JSON.parse(o.innerHTML)),
          e.items.forEach(function (e, o) {
            if (e.variant_id === GWP_GIFT_VARIANT_ID)
              0 === e.line_price ? (a = !0) : (i = o + 1);
            else {
              n.cart
                .filter((t) => t.product_id == e.product_id)[0]
                .tags.includes(GWP_QUALIFYING_COLLECTION) && (t += e.quantity);
            }
          });
      }
      var s = t >= GWP_QUANTITY_THRESHOLD;
      1 == n && (s = !0),
        i
          ? (!a && s) ||
            (console.log('GWP:', 'Extra gift products found'),
            $.post('/cart/change.json', { line: i, quantity: 0 }).done(
              function () {
                console.log('GWP:', 'Extra gift products removed'),
                  ajaxCart && ajaxCart.load();
              }
            ))
          : !a && s
          ? (console.log('GWP:', 'Qualified.'),
            $.post('/cart/add.json', {
              id: GWP_GIFT_VARIANT_ID,
              quantity: 1,
            }).done(function () {
              console.log('GWP:', 'Gift added.'), ajaxCart && ajaxCart.load();
            }))
          : a && !s
          ? (console.log('GWP:', 'Not qualified.'),
            $.post('/cart/change.json', {
              id: GWP_GIFT_VARIANT_ID,
              quantity: 0,
            }).done(function () {
              console.log('GWP:', 'Gift removed.'), ajaxCart && ajaxCart.load();
            }))
          : a && s
          ? (console.log('GWP:', 'Show the banner'),
            $.post('/cart/change.json', {
              id: GWP_GIFT_VARIANT_ID,
              quantity: 1,
            }),
            $('#gwp').addClass('gwp--visible'))
          : a ||
            s ||
            (console.log('GWP:', 'Hide the banner'),
            $('#gwp').removeClass('gwp--visible'));
    }));
}
 // gwp
 document.addEventListener('DOMContentLoaded', function() {
  var body = document.querySelector('body');
  if (body.classList.contains('template-cart')) {
    checkGiftWithPurchase();
    console.log('gwp')
  }
});